import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function UberUns() {
  const navigate = useNavigate();
  const handleCallClick = () => {
    window.location.href = "tel:+491734317404";
  };

  return (
    <div
      id="uber-uns"
      className="max-w-7xl mx-auto flex flex-col lg:flex-row py-20 px-6 md:px-10 gap-12 lg:gap-20 items-center"
    >
      <motion.div
        className="flex-1 flex flex-col gap-6 items-center text-center lg:items-start lg:text-left"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-4xl md:text-5xl lg:text-7xl text-darkBlue font-bold leading-tight">
          Wir bauen Gebäude Neu und Um.
        </h2>
        <p className="max-w-xl text-gray-500 leading-relaxed">
          Wir sind Experten für nachhaltige Bau- und Infrastrukturprojekte. Seit
          2021 realisieren wir innovative Lösungen, die höchsten Ansprüchen an
          Qualität, Funktionalität und Umweltverträglichkeit gerecht werden.
        </p>
        <motion.button
          onClick={handleCallClick}
          className="px-8 py-3 bg-darkBlue rounded-lg text-white font-medium hover:bg-blue-800 transition-colors"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Kontakt
        </motion.button>
      </motion.div>

      <motion.div
        className="flex-1 relative h-[400px] md:h-[500px] w-full max-w-lg"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.15 }}
      >
        <motion.img
          className="object-cover absolute w-[60%] h-[70%] rounded-lg shadow-lg top-0 left-0 cursor-pointer"
          src="./special4.png"
          alt="Bauprojekt"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
          onClick={() => navigate("/projekte")}
        />
        <motion.img
          className="object-cover absolute w-[60%] h-[70%] rounded-lg shadow-lg bottom-0 right-0 cursor-pointer"
          src="./6.jpg"
          alt="Über uns"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
          onClick={() => navigate("/projekte")}
        />
      </motion.div>
    </div>
  );
}
